export default __webpack_public_path__ + "static/media/4h.f45be854.png";